var React = require('react');

function Play (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"noun_play_button_3179624","data-name":"noun_play button_3179624","d":"M250.24,6.7H157.045a3.347,3.347,0,0,0-3.345,3.345v93.31a3.347,3.347,0,0,0,3.345,3.345h93.31a3.347,3.347,0,0,0,3.345-3.345V10.045A3.527,3.527,0,0,0,250.24,6.7ZM221.981,59.526,193.031,76.25a3.056,3.056,0,0,1-3.23,0,3.289,3.289,0,0,1-1.615-2.883V39.918a3.289,3.289,0,0,1,1.615-2.883,3.45,3.45,0,0,1,3.345,0L222.1,53.759a3.289,3.289,0,0,1,1.615,2.883A3.4,3.4,0,0,1,221.981,59.526Z","transform":"translate(-153.7 -6.7)","fill":"#fff"}));
}

Play.defaultProps = {"id":"Component_10_18","data-name":"Component 10 – 18","width":"100","height":"100","viewBox":"0 0 100 100"};

module.exports = Play;

Play.default = Play;
